module.exports = __webpack_public_path__ + "static/media/users-active.6dddbf58.svg";